import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Checkbox, Input, InputNumber } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useNavigate } from 'react-router-dom';
import { createCategory, findCategoryById, updateCategory } from '../../../../service/categoryService';
import { CategoryRequest } from '../../../../model/request';
import toast, { NotifyType } from '../../../../utils/toast';
import HeaderAction from '../HeaderAction';
import processError from '../../../../utils/processError';

function CategoryForm() {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [webViewActive, setWebViewActive] = useState(true);
  const [webViewOrder, setWebViewOrder] = useState<number>(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      findCategoryById(id)
        .then((category) => {
          setName(category.name);
          setDescription(category.description || '');
          setWebViewActive(category.webViewActive);
          setWebViewOrder(category.webViewOrder);
        })
        .catch((e) => console.error(e));
    }
  }, [id]);

  function handleGoBack() {
    navigate('/learning-assets/categories');
  }

  async function handleSubmit() {
    try {
      const categoryRequest: CategoryRequest = {
        name,
        description,
        webViewActive: webViewActive,
        webViewOrder: webViewOrder,
      };
      id ? await updateCategory(id, categoryRequest) : await createCategory(categoryRequest);
      toast(NotifyType.INFO, id ? 'Cập nhật chủ đề thành công' : 'Tạo chủ đề thành công');
      navigate('/learning-assets/categories');
    } catch (err) {
      processError(err);
    }
  }

  return (
    <div className={'w-full h-full bg-white flex flex-col'}>
      <HeaderAction handleGoBack={handleGoBack} handleSubmit={handleSubmit} />
      <div className={'w-full p-8 h-[calc(100vh-160px)] overflow-y-auto'}>
        <h2 className={'font-bold text-xl'}>{id ? 'Chỉnh sửa chủ đề' : 'Thêm chủ đề mới'}</h2>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Tên chủ đề:</div>
          <Input className="flex-1" name={'name'} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Mô tả chi tiết:</div>
          <TextArea
            className="flex-1"
            name={'description'}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={6}
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>Hiển thị trên web</label> <br />
          <Checkbox checked={webViewActive} onChange={(e) => setWebViewActive(e.target.checked)} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>
            Độ ưu tiên hiển thị <span className={'text-FF1D30'}>*</span>
          </label>{' '}
          <br />
          <InputNumber
            placeholder="Nhập độ ưu tiên hiển thị..."
            value={webViewOrder}
            onChange={(e) => setWebViewOrder(e || 1)}
            required
          />
        </div>
      </div>
    </div>
  );
}

export default CategoryForm;
